import React from "react";
import "../../assets/css/Profile.css";
import "../../assets/css/tableRoundHeader.css";

/*
 * Team attendance metrics.
 *
 * This screen previously rendered eight identical hard-coded rows -
 * "Jatin", "9h 12m", "100%" - regardless of who was on the team or what they
 * had actually done (QA finding REPORT-01). Those figures looked like real
 * attendance data and could be acted on as such.
 *
 * They are withheld until they can be calculated honestly, which needs:
 *   - a defined office start time, so "on time" means something measurable;
 *     none is configured anywhere today, and choosing one is a policy decision;
 *   - reliable timestamps: check-in and check-out are stored as free-text
 *     strings and the attendance date as a locale-formatted string, which
 *     also causes the after-midnight checkout fault (QA finding ATTEND-02);
 *   - a stated date range for the averages.
 */
function Team() {
  return (
    <div
      className="Text14Semi primary2"
      style={{
        width: "80%",
        marginTop: "15px",
        padding: "28px 32px",
        background: "#EFF0F5",
        borderRadius: "8px",
        lineHeight: 1.6,
      }}
    >
      <div className="Text16N1" style={{ marginBottom: "8px" }}>
        Team attendance metrics are not available yet
      </div>
      <div className="Text12" style={{ maxWidth: "60ch" }}>
        Average hours and on-time arrival will appear here once an office start
        time has been set and attendance is recorded with reliable timestamps.
        Until then no figures are shown, rather than placeholder ones.
      </div>
    </div>
  );
}

export default Team;
